<template>
  <div class="drag2" :hidden="!ifShow">
    <el-form :inline="true" :model="businessData" :rules="rules" ref="businessDataForm" label-width="100px">
      <el-row type="flex" justify="center">
        <el-col>
          <el-form-item label="节点code" prop="nodeCode">
            <el-input v-model="businessData.nodeCode" style="width: 270px" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col>
          <el-form-item label="节点名称" prop="nodeName">
            <el-input v-model="businessData.nodeName" style="width: 270px" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col>
          <el-tabs v-model="activeNodeName" type="card">
            <el-tab-pane label="策略配置" name="first">
              <el-form-item label="策略code" prop="strategyCode">
                <el-input v-model="businessData.strategyCode" style="width: 270px" disabled></el-input>
              </el-form-item>
              <el-form-item label="策略名称" prop="strategyName">
                <el-input v-model="businessData.strategyName" style="width: 270px" @blur="saveBusinessData('strategyName')"></el-input>
              </el-form-item>
              <h1 style="margin: -2px 0 20px 40px"><span>策略版本</span><span style="margin-left: 10px">{{businessData.strategyVersion}}，草稿</span></h1>
              <el-form-item label="版本描述" prop="strategyVersionDesc">
                <el-input v-model="businessData.strategyVersionDesc" placeholder="版本描述" type="textarea" rows="10" cols="30" style="width: 250px" @blur="saveBusinessData('strategyVersionDesc')"></el-input>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="接口配置" name="inputConfig">
              <el-form-item prop="voConfigs">
                <el-input v-model="businessData.inputConfig" disabled type="textarea" rows="10" cols="30" style="width: 350px;margin-left: 5px"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>

export default {
  props: {
    ifShow: Boolean,
    nodeData: Object
  },
  data () {
    return {
      editable: false,
      businessData: {
        nodeCode: 'start',
        nodeName: '开始',
        strategyCode: 'dae_credit',
        strategyName: '大额额度策略',
        strategyVersion: '2.1',
        strategyVersionDesc: '这是策略描述，一个版本有自己的一个描述',
        inputConfig: '输入参数\n • customer_id   用户id\n • apply_id   申请id\n • time   时间\n'
      },
      rules: {
        code: [
          { required: true, message: '请输入节点code', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入节点名称', trigger: 'blur' }
        ],
        comment: [
          { required: true, message: '请输入策略描述', trigger: 'blur' }
        ]
      },
      showAddFlag: false,
      activeNodeName: 'first'
    }
  },
  watch: {
    'nodeData.business' (value) {
      if (!this.editable) {
        this.businessData = this.$utils.clone(value, true)
        this.editable = true
      }
    }
  },
  methods: {
    saveBusinessData (propName) {
      console.info('saveBusinessData:propName:', propName)
      let node = this.$utils.clone(this.nodeData.node, true)
      let business = this.$utils.clone(this.businessData, true)
      this.$emit('saveNodesData', {node: node, business: business})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/decisionTree/start-node-business.vue